<template>
  <div
    class="cpt-hero-list"
    ref="list"
    v-hb-list-loading:callback="page_loading"
  >
    <div class="list-wrapper" v-if="pal_list.length > 0">
      <div class="left-panel">
        <div
          class="list-header"
          :class="{ fixed: isPinned, pinned: isPinned }"
          :style="{ top: `${isPinned && show_nav ? navHeight : 0}px` }"
        >
          <div class="col-1" @click="handleSortByID">
            <div class="text">帕鲁</div>
          </div>
        </div>
        <div class="list-content">
          <div
            class="row"
            v-for="(pal, index) in pal_list"
            :key="pal.en_name + '-' + index"
            @click="handleJumpPalDetail(pal)"
          >
            <div class="col-1">
              <div class="icon" :class="[`rarity-${pal.rarity}`]">
                <img v-src="pal.icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-panel">
        <div
          class="list-header"
          :style="{ top: `${isPinned && show_nav ? navHeight : 0}px` }"
          :class="{ fixed: isPinned, pinned: isPinned }"
          ref="right-panel-header"
        >
          <div class="col col-pal-id"
            :class="[
              active_tab == 'id' && !is_desc ? 'rotate' : '',
              active_tab == 'id' ? 'active' : '',
            ]"
            @click="handleHeaderClick({is_sortable: true, key: 'id'})"
          >
            <div class="text">编号</div>
            <hb-icon
              v-if="'id' == active_tab"
              common-arrow-down-filled
            ></hb-icon>
          </div>
          <div
            class="col"
            v-for="item in header_list"
            :key="item.key"
            :class="[
              item.key == active_tab && !is_desc ? 'rotate' : '',
              `col-${item.key}`,
              item.key == active_tab ? 'active' : '',
            ]"
            @click="handleHeaderClick(item)"
          >
            <div class="text">{{ item.label }}</div>
            <hb-icon
              v-if="item.key == active_tab"
              common-arrow-down-filled
            ></hb-icon>
          </div>
        </div>
        <div class="list-content" @scroll="handleRightPanelScoll">
          <div
            class="row"
            v-for="(pal, index) in pal_list"
            :key="pal.en_name + '-' + index"
            @click="handleJumpPalDetail(pal)"
          >
            <div class="col col-pal-info">
              <div class="pal-wrapper">
                <div class="name-row">{{ pal.name }}</div>
                <div class="en-name-row">{{ pal.en_name }}</div>
              </div>
            </div>
            <div
              :class="[`col-${block.key}`]"
              class="col"
              v-for="block in pal.tab_values"
              :key="block.key"
            >
              <div class="property-wrapper" v-if="block.key == 'property'">
                <img
                  class="property-icon"
                  v-for="(icon, index) in block.attrs"
                  :key="`property${index}`"
                  v-src="icon.icon"
                />
              </div>
              <div class="skill-wrapper" v-else-if="block.key == 'build'">
                <div
                  class="skill-item"
                  v-for="(skill, index) in block.attrs"
                  :key="`build${index}`"
                >
                  <div class="icon-wrapper">
                    <img v-src="skill.icon" />
                    <div class="level-wrapper">{{ skill.value }}</div>
                  </div>
                </div>
              </div>
              <div
                class="partner-skill-wrapper"
                v-else-if="block.key == 'partner_skill'"
              >
                <img
                  v-src="skill.icon"
                  v-for="(skill, index) in block.attrs"
                  :key="`pskill${index}`"
                />
              </div>
              <div class="value-wrapper" v-else>
                <span v-for="(skill, index) in block.attrs" :key="index">{{
                  skill.value
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="empty-wrapper" v-else>
      <hb-empty
        color="rgba(255,255,255, 0.6)"
        desc="暂无符合要求的帕鲁"
      ></hb-empty>
    </div>
  </div>
</template>

<script>
import { executeProtocol, registerNativeCallback } from '_lib/utils';
import { jumpPalDetailPage } from '../../../assets/js/common.js';
export default {
  props: {
    pal_list: {
      type: Array,
      default: () => [],
    },
    header_list: {
      type: Array,
      default: () => [],
    },
    navHeight: {
      type: Number,
      default: 0,
    },
    active_tab: {
      type: String,
      default: '',
    },
    is_desc: {
      type: Boolean,
      default: false,
    },
    page_loading: {
      type: Boolean,
      default: false,
    },
    show_nav: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      posTop: null,
      isPinned: false,

      // active_tab: '',
      // is_desc: true,
      callback() {
        this.$emit('need_load');
      },
    };
  },
  mounted() {
    this.posTop =
      this.$refs.list.offsetTop - (this.show_nav ? this.navHeight : 0);
    window.addEventListener('scroll', () => {
      if (
        window.scrollY > this.posTop ||
        document.documentElement.scrollTop > this.posTop
      ) {
        this.isPinned = true;
      } else {
        this.isPinned = false;
      }
    });
    registerNativeCallback('pageHiddenToBackend', () => {
      this._jump_lock = false;
    });
    registerNativeCallback('pageHiddenToOthersPage', () => {
      this._jump_lock = false;
      executeProtocol({
        protocol_type: 'showWaiting',
        show: '0',
      });
    });
  },
  methods: {
    handleHeaderClick(item) {
      let cur_scroll =
        document.body.scrollTop || document.documentElement.scrollTop;
      window.scrollTo(0, Math.min(this.posTop + 1, cur_scroll));
      let key = item.key,
        seq = this.is_desc;
      if (!item.is_sortable) return;
      if (this.active_tab == item.key) {
        seq = !this.is_desc;
      } else {
        key = item.key;
        seq = true;
      }
      this.$emit('change_seq', key, seq);
    },
    handleSortByID() {
      this.$emit('change_seq', 'id', false);
    },
    handleRightPanelScoll(e) {
      const scrollLeft = e.target.scrollLeft;
      const leftPanelHeader = this.$refs['right-panel-header'];
      if (leftPanelHeader) {
        leftPanelHeader.style.transform = `translateX(-${scrollLeft}px)`;
      }
    },
    async handleJumpPalDetail(pal) {
      if (this._jump_lock) return;
      this._jump_lock = true;
      let url = `/game/palworld/database/pal_detail?id=${pal.id}`;
      await jumpPalDetailPage(url, pal.id);
      this._jump_lock = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import '../assets/css/font.css';
.cpt-hero-list {
  .list-wrapper {
    display: flex;
    flex-direction: row;
    position: relative;
  }

  .list-header,
  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .list-header {
    height: 30px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.5);
    font-size: 11px;
    z-index: 50;
    transition: background-color 0.1s;
    &.pinned {
      background-color: #014c6d;
      position: fixed;
      // background-color: rgba(24, 44, 75);
    }
  }

  .list-content {
    .row {
      height: 56px;
      position: relative;
    }
  }

  .left-panel {
    position: relative;
    .col-1 {
      width: 46px;
    }

    .list-header {
      padding: 0 0 0 12px;
      position: absolute;
      left: 0;
      top: 0;
      will-change: transform;
      z-index: 200;
      &.pinned {
        background-color: #014c6d;
        position: fixed;
      }

      .col-1 {
        display: flex;
        justify-content: space-between;
      }
    }

    .list-content {
      padding-top: 30px;
      position: relative;
      .row {
        padding: 0 0 0 12px;

        &::before {
          content: '';
          width: 100vw;
          height: 1px;
          position: absolute;
          left: 0;
          top: 0;
          background-color: rgba(255, 255, 255, 0.1);
          transform: scaleY(0.5);
        }

        .col-1 {
          display: flex;
          align-items: center;

          .icon {
            flex-shrink: 0;
            width: 40px;
            height: 40px;
            border-radius: 3px;
            position: relative;
            flex-shrink: 0;
            box-sizing: border-box;
            position: relative;
            background: rgba(255, 255, 255, 0.1);
            &.rarity-Common {
              border: 2px solid #7e7e7e;
            }
            &.rarity-Rare {
              border: 2px solid #6a92ff;
            }
            &.rarity-Epic {
              border: 2px solid #b963ff;
            }
            &.rarity-Legendary {
              border: 2px solid #ff9557;
            }

            img {
              position: absolute;
              width: 40px;
              height: 40px;
              right: -2px;
              bottom: -2px;
              border-radius: 3px;
            }
          }
        }
      }
    }
  }

  .right-panel {
    width: 0;
    flex: 1;
    overflow: hidden;
    position: relative;
    overscroll-behavior: none;

    &::-webkit-scrollbar {
      display: none;
    }

    .col {
      flex-shrink: 0;
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .list-header {
      position: absolute;
      left: 0;
      top: 0;
      will-change: transform;
      &.fixed {
        left: 58px;
        position: fixed;
      }
      .col {
        &.active {
          color: #fff;
        }
        i {
          font-size: 10px;
          transform: scale(0.8);
        }
        &.rotate {
          i {
            transform: scale(0.8) rotate(180deg);
          }
        }
      }
      .col-pal-id {
        padding-left: 10px;
        justify-content: flex-start;
        align-items: center;
        width: 80px;
        flex-shrink: 0;
      }
    }

    .list-content {
      width: 100%;
      padding-top: 30px;
      overflow-x: auto;
      position: relative;
      &::-webkit-scrollbar {
        display: none;
      }
    }

    .row {
      .col {
        display: flex;
        align-items: center;
        flex-direction: column;
      }
    }

    .col-pal-info {
      width: 80px;
      padding-left: 10px;
      align-items: flex-start !important;
      .name-row {
        width: 100%;
        color: #fff;
        font-size: 13px;
        font-weight: 500;
        height: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .en-name-row {
        width: 100%;
        margin-top: 2px;
        color: rgba(255, 255, 255, 0.5);
        font-size: 10px;
        line-height: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .col-property {
      width: 54px;
      .property-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .property-icon {
          width: 22px;
          height: 22px;
        }
      }
    }
    .col-build {
      width: 117px;
      .skill-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 2px;
        padding: 0 9px;
        .skill-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin: 0 1px 1px 0;
          .icon-wrapper {
            width: 20px;
            height: 20px;
            background: rgba(255, 255, 255, 0.05);
            border-radius: 2px;
            position: relative;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
            .level-wrapper {
              position: absolute;
              bottom: 0;
              right: 0;
              border-radius: 2px 0 0 0;
              background: rgba(0, 0, 0, 0.2);
              height: 11px;
              padding: 0 2px;
              color: #fff;
              text-align: center;
              font-family: 'Helvetica';
              font-size: 10px;
              font-weight: 700;
              line-height: 11px;
            }
          }
          .level-wrapper {
            margin-top: 2px;
            display: flex;
            flex-direction: row;
            .level-dot {
              height: 2px;
              width: 4px;
              border-radius: 1px;
              background: rgba(255, 255, 255, 0.8);
              &:not(:last-child) {
                margin-right: 1px;
              }
            }
          }
        }
      }
    }
    .col-partner_skill {
      width: 37px;
      .partner-skill-wrapper {
        width: 30px;
        height: 30px;
        border-radius: 3px;
        background: rgba(255, 255, 255, 0.05);
        img {
          width: 30px;
          height: 30px;
        }
      }
    }
    .col-rarity,
    .col-hp {
      width: 47px;
    }
    .col-breed {
      width: 58px;
    }
    .col-defence,
    .col-stamina {
      width: 36px;
    }
    .col-price {
      width: 36px;
    }
    .col-speed {
      width: 70px;
      padding-right: 12px;
    }
    .value-wrapper {
      span {
        color: #fff;
        font-family: Helvetica !important;
        font-size: 13px;
        font-weight: 700;
        line-height: 16px;
      }
    }
  }

  .empty-wrapper {
    width: 100%;
    height: 150px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
}
</style>
